import {
    RECEIVE_NEWS_SUBPAGE,
    REQUEST_NEWS_SUBPAGE,
    SET_NEWS_SUBPAGE_ERROR,
    RECEIVE_NEWS_CATEGORY,
    REQUEST_NEWS_CATEGORY,
    SET_NEWS_CATEGORY_ERROR,
  } from '../constants/ActionTypes';

const initialState = {
    isFetching: false,
    isLoadingError: false
};

export default function news(state = initialState, action) {
    switch (action.type) {
        case SET_NEWS_SUBPAGE_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case REQUEST_NEWS_SUBPAGE:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case RECEIVE_NEWS_SUBPAGE:
            return {
                ...state,
                isFetching: false,
                pageData: action.data
            };
        case SET_NEWS_CATEGORY_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case REQUEST_NEWS_CATEGORY:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case RECEIVE_NEWS_CATEGORY:
            return {
                ...state,
                isFetching: false,
                pageDataCategory: action.data
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/news.js